import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Splash from '@/pages/Splash'
import Seguranca from '@/pages/Seguranca'
import Construcao from '@/pages/Construcao'
import Programa from '@/pages/Programa'
import Intervencao from '@/pages/Intervencao'
import Brasil from '@/components/Mapas/Brasil'
import SaibaMais from '@/pages/SaibaMais'
import Monitoramento from '@/pages/Monitoramento'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'splash',
            component: Splash
        },
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/seguranca',
            name: 'seguranca',
            component: Seguranca
        },
        {
            path: '/construcao',
            name: 'construcao',
            component: Construcao
        },
        {
            path: '/programa',
            name: 'Programa',
            component: Programa
        },
        {
            path: '/saibamais',
            name: 'SaibaMais',
            component: SaibaMais
        },
        {
            path: '/intervencao',
            name: 'intervencao',
            component: Intervencao,
            children: [{
                path: 'brasil',
                component: Brasil
            }]
        },
        {
            path: '/monitoramento',
            name: 'monitoramento',
            component: Monitoramento,
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['Auth/authStatus']) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})

export default router